import { Random } from 'Utility/Random';
import Game from 'Game';

export enum LocalNotificationTag {
    INACTIVITY_1,
    INACTIVITY_2,
    INACTIVITY_3,
    INACTIVITY_4,
}

type InactivityNotification = { tag: LocalNotificationTag; inactiveHours: number; getBody: () => string };

export const InactivityNotifications: InactivityNotification[] = [
    {
        tag: LocalNotificationTag.INACTIVITY_1,
        inactiveHours: 24,
        getBody: () => Game.locale.getText(`LocalNotification_Inactivity_24h_${Random.int(1, 2)}`),
    },
    {
        tag: LocalNotificationTag.INACTIVITY_2,
        inactiveHours: 24 * 3,
        getBody: () => Game.locale.getText(`LocalNotification_Inactivity_3Days_${Random.int(1, 2)}`),
    },
    {
        tag: LocalNotificationTag.INACTIVITY_3,
        inactiveHours: 24 * 7,
        getBody: () => Game.locale.getText(`LocalNotification_Inactivity_7Days_${Random.int(1, 2)}`),
    },
    {
        tag: LocalNotificationTag.INACTIVITY_4,
        inactiveHours: 24 * 14,
        getBody: () => Game.locale.getText(`LocalNotification_Inactivity_14Days_${Random.int(1, 2)}`),
    },
];
